/* NIKOLE COLLECTION – logika motywu (wspólna dla obu wersji) */
(() => {
  const NC = window.NC || {};
  const T = NC.t || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const store = {
    get(k, d) { try { const v = localStorage.getItem('nc_' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem('nc_' + k, JSON.stringify(v)); } catch (e) {} }
  };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- kwoty w formacie sklepu ---------- */
  function money(cents) {
    const fmt = NC.moneyFormat || '{{amount}} zł';
    const n = (cents || 0) / 100;
    const f = (dec, th, ds) => { const [i, d] = n.toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: f(2, ',', '.'), amount_no_decimals: f(0, ',', '.'), amount_with_comma_separator: f(2, '.', ','),
      amount_no_decimals_with_comma_separator: f(0, '.', ','), amount_with_space_separator: f(2, ' ', ','),
      amount_with_period_and_space_separator: f(2, ' ', '.'), amount_with_apostrophe_separator: f(2, "'", '.')
    }[k] || f(2, ',', '.')));
  }

  /* ---------- komunikat ---------- */
  let toastT;
  function toast(title, body, img, bagLink) {
    const el = $('#toast'); if (!el) return;
    el.classList.toggle('noimg', !img);
    el.innerHTML = `${img ? `<img src="${esc(img)}" alt="">` : ''}<div><b>${esc(title)}</b>${body ? `<span>${esc(body)}</span>` : ''}${bagLink ? `<br><button class="u-link" type="button" data-open="cart">${esc(T.viewBag)}</button>` : ''}</div>`;
    el.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove('on'), 3000);
  }

  /* ---------- delikatny komunikat (ulubione) ---------- */
  let pillT;
  function pill(text, on) {
    let el = $('#nc-pill');
    if (!el) { el = document.createElement('div'); el.id = 'nc-pill'; el.className = 'pill'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); document.body.appendChild(el); }
    const wl = $('a[href*="/pages/"] [data-wish-count]'), href = wl ? wl.closest('a').getAttribute('href') : '';
    el.classList.toggle('pill--on', !!on);
    el.innerHTML = `<svg class="ico" viewBox="0 0 24 24" fill="${on ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10C19.5 15.4 12 20 12 20z"/></svg><span>${esc(text)}</span>${on && href ? `<a href="${href}">${esc(T.wView || '')}</a>` : ''}`;
    el.classList.remove('show'); void el.offsetWidth; el.classList.add('show');
    clearTimeout(pillT); pillT = setTimeout(() => el.classList.remove('show'), 2600);
  }

  /* ---------- panele, okna ---------- */
  let openId = null;
  function setPanel(id) {
    if (id === 'cart' && NC.cartType !== 'drawer') { location.href = NC.routes.cart; return; }
    if (id === 'menu') { const h = $('[data-header]'), m = $('#menu'); if (h && m && !m.classList.contains('mm--full')) m.style.top = Math.max(0, h.getBoundingClientRect().bottom) + 'px'; }
    $$('[data-panel]').forEach(p => p.classList.toggle('on', p.id === id));
    document.body.classList.toggle('panel-open', !!id && id !== 'search' && id !== 'menu');
    document.body.classList.toggle('lock', !!id);
    $$('[data-open]').forEach(b => b.setAttribute('aria-expanded', b.dataset.open === id));
    $$('[data-menu-icon]').forEach(b => b.classList.toggle('is-open', id === 'menu'));
    openId = id;
    document.dispatchEvent(new CustomEvent('nc:panel', { detail: id }));
    if (id === 'cart') renderCart();
    if (id === 'search') setTimeout(() => { const i = $('[data-search-input]'); i && i.focus(); }, 60);
    closeMega();
  }
  function modal(html, onReady) {
    const m = $('[data-modal]'); if (!m) return;
    $('[data-modal-body]', m).innerHTML = html;
    m.classList.add('on'); document.body.classList.add('lock');
    onReady && onReady($('[data-modal-body]', m));
    const f = $('input:not([type=hidden])', m); if (f) setTimeout(() => f.focus(), 60);
  }
  function closeModal() { const m = $('[data-modal]'); if (m) m.classList.remove('on'); if (!openId) document.body.classList.remove('lock'); }
  function fromTpl(id) { const t = document.getElementById(id); return t ? t.innerHTML : ''; }
  function openNotify(product, variant) {
    modal(fromTpl('tpl-notify'), body => {
      const label = product + (variant ? ' · ' + variant : '');
      const p = $('[data-notify-product]', body); if (p) p.textContent = label;
      const b = $('[data-notify-body]', body); if (b) b.value = 'Powiadom mnie o dostępności: ' + label + ' – ' + location.href.split('?')[0];
      store.set('notify_pending', 1);
    });
  }

  /* ---------- produkt: dobierz do kompletu ---------- */
  function initPdpBundle() {
    $$('[data-bundle-pdp]').forEach(async box => {
      let cols = []; try { cols = JSON.parse(box.dataset.cols || '[]'); } catch (e) {}
      const cart = await getCart(), have = [...new Set((await Promise.all(cart.items.map(i => colsOf(i.handle)))).flat())];
      renderBundle(box, cols, have, [box.dataset.handle, ...cart.items.map(i => i.handle)]);
    });
  }

  /* ---------- karta produktu: przewijanie zdjęć na telefonie ---------- */
  function initCardSwipe() {
    document.addEventListener('scroll', e => {
      const sc = e.target; if (!sc.closest || !sc.closest('.pc--sw')) return;
      const card = sc.closest('.pc'), i = Math.round(sc.scrollLeft / sc.clientWidth);
      $$('.pc__dots i', card).forEach((d, k) => d.classList.toggle('on', k === i));
    }, { capture: true, passive: true });
  }

  /* ---------- menu na telefonie (ekrany) ---------- */
  function initMobileMenu() {
    const w = $('[data-mm]'); if (!w) return;
    const show = (id, back) => {
      const cur = $('.mm__s.on', w), nx = document.getElementById(id); if (!nx || nx === cur) return;
      $$('.mm__s.out', w).forEach(x => x.classList.remove('out'));
      if (cur) { cur.classList.remove('on'); if (!back) cur.classList.add('out'); }
      if (back) { nx.classList.remove('out'); }
      nx.scrollTop = 0; nx.classList.add('on');
    };
    w.addEventListener('click', e => {
      const g = e.target.closest('[data-mm-go]'); if (g) return show(g.dataset.mmGo);
      const b = e.target.closest('[data-mm-back]'); if (b) show(b.dataset.mmBack, true);
    });
    document.addEventListener('nc:panel', e => { if (e.detail !== 'menu') setTimeout(() => { $$('.mm__s', w).forEach(x => x.classList.remove('on', 'out')); $('#mm-0').classList.add('on'); }, 350); });
  }

  /* ---------- mega menu ---------- */
  function closeMega() { $$('[data-mega]').forEach(m => m.classList.remove('on')); $$('[data-mega-btn]').forEach(b => b.setAttribute('aria-expanded', 'false')); }
  function initMega() {
    $$('[data-mega-btn]').forEach(b => {
      const m = document.getElementById(b.getAttribute('aria-controls')); if (!m) return;
      const side = m.classList.contains('mega--side');
      const open = () => {
        closeMega();
        if (side) { m.style.top = Math.max(0, b.closest('[data-header]').getBoundingClientRect().bottom) + 'px'; m.classList.remove('l2'); $$('.msd2', m).forEach(x => x.classList.remove('on')); $$('[data-l2]', m).forEach(x => x.setAttribute('aria-expanded', 'false')); }
        m.classList.add('on'); b.setAttribute('aria-expanded', 'true');
      };
      b.addEventListener('click', e => { e.preventDefault(); m.classList.contains('on') ? closeMega() : open(); });
      if (!side) b.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover) and (min-width: 900px)').matches) open(); });
    });
    $$('[data-header]').forEach(h => h.addEventListener('mouseleave', () => { if (matchMedia('(hover: hover)').matches && !$('.mega--side.on')) closeMega(); }));
    $$('[data-cm-tab]').forEach(b => { const go = () => {
      const m = b.closest('[data-mega]');
      $$('[data-cm-tab]', m).forEach(x => { x.setAttribute('aria-selected', x === b); const p = document.getElementById(x.dataset.cmTab); if (p) p.hidden = x !== b; });
    }; b.addEventListener('click', go); b.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) go(); }); });
    $$('[data-l2]').forEach(b => b.addEventListener('click', () => {
      const m = b.closest('[data-mega]'), p = document.getElementById(b.dataset.l2), was = p.classList.contains('on');
      $$('.msd2', m).forEach(x => x.classList.remove('on')); $$('[data-l2]', m).forEach(x => x.setAttribute('aria-expanded', 'false'));
      if (!was) { p.classList.add('on'); b.setAttribute('aria-expanded', 'true'); }
      m.classList.toggle('l2', !was);
    }));
    document.addEventListener('click', e => { if (e.target.closest('[data-mega-close]') || e.target.matches('[data-mega]') || !e.target.closest('[data-mega], [data-mega-btn]')) closeMega(); });
    addEventListener('keydown', e => { if (e.key === 'Escape') closeMega(); });
  }

  /* ---------- nagłówek: zwijanie przy przewijaniu ---------- */
  function initHeader() {
    const h = $('[data-header]'); if (!h) return;
    const limit = +h.dataset.compactAfter || 80;
    const tr = $('[data-transparent]');
    const on = () => {
      h.classList.toggle('compact', scrollY > limit);
      if (tr) { const hero = $('.sec-hero, .hero'); const end = hero ? hero.offsetTop + hero.offsetHeight - h.offsetHeight : 0; document.body.classList.toggle('hd-solid', scrollY > end - 1); }
    };
    addEventListener('scroll', on, { passive: true }); on();
    const ann = $('[data-ann]');
    if (ann) {
      if (store.get('ann_closed', '') === ann.dataset.ann) ann.remove();
      else {
        const more = $('[data-ann-more]', ann); if (more) more.addEventListener('click', () => { ann.classList.toggle('open'); more.setAttribute('aria-expanded', ann.classList.contains('open')); });
        const x = $('[data-ann-close]', ann); if (x) x.addEventListener('click', () => { ann.remove(); store.set('ann_closed', ann.dataset.ann); });
      }
    }
  }

  /* ---------- koszyk ---------- */
  async function getCart() { const r = await fetch(NC.routes.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  function setCounts(n) {
    $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = !n; });
    $$('[data-cart-count-label]').forEach(el => el.textContent = n ? `(${n})` : '');
  }
  /* ---------- komplety i polecane: wspólne ---------- */
  const cents = v => typeof v === 'string' ? Math.round(parseFloat(v) * 100) : (v || 0);
  const pImg = p => p.featured_image ? (p.featured_image.src || p.featured_image) : (p.images && p.images[0] ? (p.images[0].src || p.images[0]) : '');
  const memo = {};
  async function colsOf(handle) {
    const k = 'nccol:' + handle, c = store.get(k, null); if (c) return c;
    try { const r = await fetch(NC.routes.root + 'products/' + handle + '?view=nccol'); const j = await r.json(); store.set(k, j); return j; } catch (e) { return []; }
  }
  async function collProducts(handle) {
    if (!memo[handle]) memo[handle] = fetch(NC.routes.root + 'collections/' + handle + '/products.json?limit=16').then(r => r.json()).then(j => j.products || []).catch(() => []);
    return memo[handle];
  }
  function bundleTargets(cols, haveCols) {
    const out = [];
    (NC.bundle.pairs || []).forEach(([a, b, t]) => { if (cols.includes(a) && !haveCols.includes(b) && !out.some(o => o.b === b)) out.push({ b, t }); });
    return out;
  }
  function miniCard(p, pct) {
    const vs = (p.variants || []).filter(v => v.available !== false);
    if (!vs.length) return '';
    const price = cents(vs[0].price), np = pct ? Math.round(price * (100 - pct) / 100) : price;
    const single = vs.length === 1 && /default/i.test(vs[0].title || '');
    const add = single
      ? `<button class="mc__add" type="button" data-qadd="${vs[0].id}">${esc(T.add)}</button>`
      : `<div class="mc__sz">${vs.map(v => `<button type="button" data-qadd="${v.id}">${esc(v.title)}</button>`).join('')}</div>`;
    return `<div class="mc"><a class="mc__im" href="${NC.routes.root}products/${p.handle}"><img src="${imgW(pImg(p), 300)}" alt=""></a>
      <div class="mc__i"><a class="mc__n" href="${NC.routes.root}products/${p.handle}">${esc(p.title)}</a>
      <p class="mc__p">${pct ? `<s>${money(price)}</s> <b>${money(np)}</b> <em>${esc(NC.bundle.badge || ('−' + pct + '%'))}</em>` : money(price)}</p>${add}</div></div>`;
  }
  async function renderBundle(box, cols, haveCols, exclude) {
    if (!box || !NC.bundle || !NC.bundle.on) return;
    const tg = bundleTargets(cols, haveCols);
    if (!tg.length) { box.hidden = true; box.innerHTML = ''; return; }
    let cards = '', title = '';
    for (const t of tg.slice(0, 2)) {
      const ps = (await collProducts(t.b)).filter(p => !exclude.includes(p.handle)).slice(0, 6);
      const c = ps.map(p => miniCard(p, NC.bundle.pct)).join('');
      if (c) { cards += c; title = title || t.t; }
    }
    if (!cards) { box.hidden = true; return; }
    box.hidden = false;
    box.innerHTML = `<div class="mcar__hd"><p class="mcar__t">${esc(NC.bundle.title)}${title ? ' – ' + esc(title) : ''}</p><span class="mcar__b">−${NC.bundle.pct}%</span></div><div class="mcar">${cards}</div>`;
  }
  async function renderRecs(box, productId, exclude) {
    if (!box || !NC.cartRecs || !productId) { if (box) box.hidden = true; return; }
    try {
      const r = await fetch(`${NC.recsUrl}.json?product_id=${productId}&limit=8`); const j = await r.json();
      const c = (j.products || []).filter(p => !exclude.includes(p.handle)).slice(0, 6).map(p => miniCard(p, 0)).join('');
      box.hidden = !c; box.innerHTML = c ? `<div class="mcar__hd"><p class="mcar__t">${esc(NC.cartRecs)}</p></div><div class="mcar">${c}</div>` : '';
    } catch (e) { box.hidden = true; }
  }
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-qadd]'); if (!b || b.disabled) return;
    e.preventDefault();
    const box = b.closest('.mc'); if (box) box.classList.add('busy');
    b.disabled = true;
    const ok = await addItems([{ id: +b.dataset.qadd, quantity: 1 }], { text: '' });
    b.disabled = false; if (box) box.classList.remove('busy');
    if (ok && NC.cartType === 'drawer') { const c = $('#cart'); if (c) c.querySelector('.cd__body').scrollTop = 0; }
  });

  async function renderCart(cart) {
    const box = $('[data-cart-items]'); if (!box) return;
    cart = cart || await getCart();
    setCounts(cart.item_count);
    const ft = $('[data-cart-footer]'), ship = $('[data-ship]'), bun = $('[data-cart-bundle]'), recs = $('[data-cart-recs]'), trust = $('[data-cart-trust]');
    if (!cart.item_count) {
      box.innerHTML = `<div class="empty"><p class="lab">${esc(T.empty)}</p><a class="btn" href="${NC.routes.root}collections/all">${esc(T.continueShopping)}</a></div>`;
      [ft, ship, bun, recs, trust].forEach(x => { if (x) x.hidden = true; }); return;
    }
    if (ft) ft.hidden = false; if (trust) trust.hidden = false;
    if (ship && NC.freeShipping) {
      ship.hidden = false;
      const tot = cart.total_price, t2 = NC.tier2, max = t2 && t2.amount > NC.freeShipping ? t2.amount : NC.freeShipping;
      const left = NC.freeShipping - tot;
      let txt = left > 0 ? T.shipLeft.replace('{x}', money(left)) : (t2 && tot < t2.amount ? t2.text.replace('{x}', money(t2.amount - tot)) : (t2 ? t2.ok : T.shipOk));
      $('[data-ship-text]', ship).textContent = txt;
      $('[data-ship-fill]', ship).style.width = Math.min(100, tot / max * 100) + '%';
      const m1 = $('[data-ship-m1]', ship), m2 = $('[data-ship-m2]', ship), l1 = $('[data-ship-l1]', ship), l2 = $('[data-ship-l2]', ship);
      const p1 = NC.freeShipping / max * 100;
      if (m1) { m1.style.left = p1 + '%'; m1.classList.toggle('ok', left <= 0); }
      if (l1) l1.style.left = p1 + '%';
      if (m2) m2.classList.toggle('ok', t2 && tot >= t2.amount);
      ship.classList.toggle('ok', left <= 0);
      ship.classList.toggle('one', !m2 || max === NC.freeShipping);
    }
    box.innerHTML = cart.items.map((it, i) => {
      const disc = (it.line_level_discount_allocations || []).map(d => d.discount_application && d.discount_application.title).filter(Boolean);
      return `<div class="ci">
      <a class="ci__im" href="${it.url}"><img src="${imgW(it.image, 240)}" alt="" loading="lazy"></a>
      <div class="ci__c"><div class="ci__top"><a class="ci__n" href="${it.url}">${esc(it.product_title)}</a>
        <p class="ci__p">${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s> ` : ''}${money(it.final_line_price)}</p></div>
        ${it.product_has_only_default_variant ? '' : `<p class="ci__m">${esc(it.variant_title)}</p>`}
        ${disc.length ? `<p class="ci__d">${esc(disc.join(' · '))}</p>` : ''}
        <div class="ci__b"><div class="qty"><button type="button" data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="-">−</button><span>${it.quantity}</span><button type="button" data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="+">+</button></div>
        <button class="rm" type="button" data-line="${i + 1}" data-q="0" aria-label="${esc(T.remove)}"><svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M4.5 6.5h15M9.5 6.5V4.5h5v2M6.5 6.5l1 13h9l1-13M10 10v6.5M14 10v6.5"/></svg></button></div></div></div>`;
    }).join('');
    const tot = $('[data-cart-total]'); if (tot) tot.textContent = money(cart.total_price);
    const dl = $('[data-cart-disc]'); if (dl) { dl.hidden = !cart.total_discount; dl.textContent = cart.total_discount ? T.saved + ' −' + money(cart.total_discount) : ''; }
    const handles = cart.items.map(it => it.handle);
    const cols = [...new Set((await Promise.all(handles.map(colsOf))).flat())];
    renderBundle(bun, cols, [], handles);
    renderRecs(recs, cart.items[0].product_id, handles);
  }
  async function changeLine(line, quantity) {
    const r = await fetch(NC.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    renderCart(await r.json());
  }
  async function addItems(items, info) {
    const r = await fetch(NC.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const data = await r.json();
    if (!r.ok) { toast(T.error, data.description || data.message || ''); return false; }
    if (NC.cartType === 'drawer') { setPanel('cart'); } else { const c = await getCart(); setCounts(c.item_count); toast(T.added, info && info.text, info && info.img, true); }
    return true;
  }

  /* ---------- lista rozmiarów ---------- */
  function closeSelects(except) { $$('[data-select]').forEach(w => { if (w === except) return; const o = $('.opts', w); if (o) o.hidden = true; const b = $('.sel', w); if (b) b.setAttribute('aria-expanded', 'false'); }); }
  function initSelect(w) {
    if (w._init) return; w._init = true;
    const btn = $('.sel', w), opts = $('.opts', w);
    btn.addEventListener('click', e => { e.stopPropagation(); const open = opts.hidden; closeSelects(w); opts.hidden = !open; btn.setAttribute('aria-expanded', open); });
    opts.addEventListener('click', e => {
      const o = e.target.closest('button'); if (!o) return; e.stopPropagation();
      opts.hidden = true; btn.setAttribute('aria-expanded', 'false');
      if (o.dataset.avail !== 'true') return openNotify(w.dataset.productTitle, o.dataset.title);
      $('[data-sel-label]', w).textContent = `${T.size}: ${o.dataset.title}`;
      w.dataset.value = o.dataset.id;
      w.dispatchEvent(new CustomEvent('nc:size', { bubbles: true, detail: { id: o.dataset.id, title: o.dataset.title, price: +o.dataset.price } }));
    });
  }

  /* ---------- ulubione ---------- */
  const wish = new Set(store.get('wish', []));
  function syncWish() {
    $$('[data-wish]').forEach(b => {
      const on = wish.has(b.dataset.wish); b.setAttribute('aria-pressed', on);
      if (b.hasAttribute('data-wish-label')) b.textContent = on ? b.dataset.lSaved : b.dataset.lSave;
    });
    $$('[data-wish-count]').forEach(el => { el.textContent = wish.size; el.hidden = !wish.size; });
  }
  function toggleWish(h) {
    const on = !wish.has(h); on ? wish.add(h) : wish.delete(h); store.set('wish', [...wish]); syncWish();
    pill(on ? T.wAdded : T.wRemoved, on);
    if ($('[data-wishlist-page]')) renderWishlist();
  }
  const productCache = {};
  async function fetchProduct(h) {
    if (productCache[h]) return productCache[h];
    try { const r = await fetch(`${NC.routes.root}products/${encodeURIComponent(h)}.js`); if (!r.ok) return null; return productCache[h] = await r.json(); } catch (e) { return null; }
  }
  const imgW = (src, w) => src ? (src.startsWith('//') ? 'https:' + src : src) + (src.includes('?') ? '&' : '?') + 'width=' + w : '';
  function cardHTML(p) {
    const icon = fromTpl('tpl-wish-icon');
    const sale = p.compare_at_price > p.price;
    const img2 = p.images[1] ? `<img src="${imgW(p.images[1], 700)}" alt="" loading="lazy">` : '';
    return `<article class="pc${p.available ? '' : ' out'}">
      <a class="pc__m" href="${p.url}">${p.available ? (sale ? `<span class="pc__tag sale">-${Math.round((1 - p.price / p.compare_at_price) * 100)}%</span>` : '') : `<span class="pc__tag">${esc(T.soldOut)}</span>`}<img class="on" src="${imgW(p.featured_image, 700)}" alt="${esc(p.title)}" loading="lazy">${img2}</a>
      ${NC.wishlistOn ? `<button class="pc__wish" type="button" data-wish="${p.handle}" aria-pressed="${wish.has(p.handle)}">${icon}</button>` : ''}
      <div class="pc__ib"><div class="pc__i"><a class="pc__n" href="${p.url}">${esc(p.title)}</a><p class="pc__p${sale ? ' sale' : ''}">${sale ? `<span>${money(p.price)}</span><s>${money(p.compare_at_price)}</s>` : money(p.price)}</p></div></div>
    </article>`;
  }
  async function renderWishlist() {
    const g = $('[data-wishlist-grid]'), empty = $('[data-wishlist-empty]'); if (!g) return;
    const list = (await Promise.all([...wish].map(fetchProduct))).filter(Boolean);
    g.innerHTML = list.map(cardHTML).join(''); empty.hidden = list.length > 0;
  }

  /* ---------- ostatnio oglądane ---------- */
  function initRecent() {
    const pd = $('[data-product]');
    if (pd) { const h = pd.dataset.productHandle; store.set('recent', [h, ...store.get('recent', []).filter(x => x !== h)].slice(0, 16)); }
    $$('[data-recent]').forEach(async sec => {
      const cur = sec.dataset.current, lim = +sec.dataset.limit || 8;
      const hs = store.get('recent', []).filter(x => x && x !== cur).slice(0, lim);
      if (!hs.length) return;
      const list = (await Promise.all(hs.map(fetchProduct))).filter(Boolean);
      if (!list.length) return;
      $('[data-recent-track]', sec).innerHTML = list.map(cardHTML).join('');
      sec.hidden = false; initCarousels(sec); syncWish();
    });
  }

  /* ---------- polecane ---------- */
  function initRecs() {
    $$('[data-recs]').forEach(async sec => {
      try {
        const r = await fetch(sec.dataset.url); const html = await r.text();
        const d = new DOMParser().parseFromString(html, 'text/html'); const n = d.querySelector('[data-recs]');
        if (n && n.innerHTML.trim()) { sec.innerHTML = n.innerHTML; initCarousels(sec); syncWish(); }
      } catch (e) {}
    });
  }

  /* ---------- karuzele ---------- */
  function initCarousels(root = document) {
    $$('[data-carousel]', root).forEach(c => {
      if (c._init) return; c._init = true;
      const tr = $('[data-car-track]', c), p = $('[data-car-prev]', c), n = $('[data-car-next]', c);
      if (!tr) return;
      const sync = () => { if (p) p.disabled = tr.scrollLeft < 4; if (n) n.disabled = tr.scrollLeft > tr.scrollWidth - tr.clientWidth - 4; };
      p && p.addEventListener('click', () => tr.scrollBy({ left: -tr.clientWidth, behavior: 'smooth' }));
      n && n.addEventListener('click', () => tr.scrollBy({ left: tr.clientWidth, behavior: 'smooth' }));
      tr.addEventListener('scroll', sync, { passive: true }); addEventListener('resize', sync); sync();
    });
  }

  /* ---------- film w banerze ---------- */
  function initHero() {
    $$('[data-hero]').forEach(h => {
      const v = $('video', h); if (!v) return;
      v.muted = true; v.playsInline = true;
      const play = $('[data-v-play]', h), snd = $('[data-v-sound]', h), bar = $('[data-v-bar]', h);
      let userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (userPaused) v.pause(); else v.play().catch(() => {});
      const sP = () => { if (!play) return; play.classList.toggle('paused', v.paused); play.setAttribute('aria-label', v.paused ? play.dataset.lPlay : play.dataset.lPause); };
      const sS = () => { if (!snd) return; snd.classList.toggle('on', !v.muted); snd.setAttribute('aria-label', v.muted ? snd.dataset.lOn : snd.dataset.lOff); };
      play && play.addEventListener('click', () => { if (v.paused) { userPaused = false; v.play(); } else { userPaused = true; v.pause(); } });
      snd && snd.addEventListener('click', () => { v.muted = !v.muted; if (!v.muted && v.paused) { userPaused = false; v.play(); } });
      v.addEventListener('play', sP); v.addEventListener('pause', sP); v.addEventListener('volumechange', sS);
      if (bar) v.addEventListener('timeupdate', () => { if (v.duration) bar.style.transform = `scaleX(${v.currentTime / v.duration})`; });
      new IntersectionObserver(([e]) => { if (e.isIntersecting) { if (!userPaused) v.play().catch(() => {}); } else v.pause(); }, { threshold: .2 }).observe(h);
      sP(); sS();
    });
  }

  /* ---------- strona produktu ---------- */
  function initProduct() {
    const pd = $('[data-product]'); if (!pd) return;
    const form = $('.buy__form', pd), idIn = $('[data-variant-id]', pd), err = $('[data-size-err]', pd);
    const title = pd.dataset.productTitle;
    pd.addEventListener('nc:size', e => { if (idIn) idIn.value = e.detail.id; if (err) err.textContent = ''; });
    if (form) form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!idIn.value) { if (err) err.textContent = T.selectSize; const s = $('[data-select]', pd); if (s) s.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-5px)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }], { duration: 280 }); return; }
      const b = $('[data-add]', form); b.disabled = true;
      const img = $('.gal__img', pd);
      await addItems([{ id: +idIn.value, quantity: 1 }], { text: title, img: img && img.currentSrc });
      b.disabled = false;
    });
    $$('[data-notify-open]', pd).forEach(b => b.addEventListener('click', () => openNotify(title, '')));
    const d = $('[data-desc]', pd), dt = $('[data-desc-toggle]', pd);
    if (dt) { if (d.scrollHeight <= 170) dt.hidden = true; dt.addEventListener('click', () => { d.classList.toggle('clip'); dt.textContent = d.classList.contains('clip') ? dt.dataset.lMore : dt.dataset.lLess; }); }
    $$('[data-tabclip]', pd).forEach(c => { const btn = c.nextElementSibling; if (c.scrollHeight > c.clientHeight + 4) { c.classList.add('cut'); btn.hidden = false; btn.addEventListener('click', () => { c.classList.toggle('open'); btn.textContent = c.classList.contains('open') ? btn.dataset.lLess : btn.dataset.lMore; }); } });
    $$('[data-tabs]', pd).forEach(t => t.addEventListener('click', e => { const b = e.target.closest('[data-tab]'); if (!b) return; $$('[data-tab]', t).forEach(x => x.setAttribute('aria-selected', x === b)); $$('[data-tabp]', t).forEach(p => p.hidden = p.dataset.tabp !== b.dataset.tab); }));
    /* galeria */
    const gal = $('[data-gallery]', pd), dots = $$('[data-gallery-dots] i', pd);
    if (gal) {
      gal.addEventListener('scroll', () => { const i = Math.round(gal.scrollLeft / gal.clientWidth); dots.forEach((x, k) => x.classList.toggle('on', k === i)); }, { passive: true });
      gal.addEventListener('click', e => { const g = e.target.closest('.gal__i'); if (g && innerWidth >= 900 && !e.target.closest('button')) g.classList.toggle('zoom'); });
      gal.addEventListener('mousemove', e => { const g = e.target.closest('.gal__i.zoom'); if (!g) return; const r = g.getBoundingClientRect(), im = $('img', g); if (im) im.style.transformOrigin = `${(e.clientX - r.left) / r.width * 100}% ${(e.clientY - r.top) / r.height * 100}%`; });
    }
  }

  /* ---------- termin dostawy ---------- */
  function initEta() {
    const els = $$('[data-eta]'); if (!els.length || !NC.eta || !NC.eta.on) return;
    const now = new Date(), work = d => d.getDay() % 6 !== 0;
    const addWork = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (work(x)) n--; } return x; };
    let ship = new Date(now); if (!work(ship) || now.getHours() >= NC.eta.cutoff) ship = addWork(ship, 1);
    const same = ship.toDateString() === now.toDateString();
    const cut = new Date(ship); cut.setHours(NC.eta.cutoff, 0, 0, 0);
    const lang = document.documentElement.lang || 'pl';
    const fd = d => d.toLocaleDateString(lang, { day: 'numeric', month: 'long' });
    const draw = () => {
      const ms = Math.max(0, cut - new Date()), tm = `${Math.floor(ms / 36e5)} h ${Math.floor(ms % 36e5 / 6e4)} min`;
      const html = (same ? `${esc(T.etaToday).replace('{time}', `<b>${tm}</b>`)}<br>` : '') + esc(T.etaDate).replace('{from}', fd(addWork(ship, NC.eta.min))).replace('{to}', fd(addWork(ship, NC.eta.max)));
      els.forEach(el => el.innerHTML = html);
    };
    draw(); if (same) setInterval(draw, 30000);
  }

  /* ---------- kup cały look ---------- */
  function initLooks() {
    $$('[data-look-section]').forEach(sec => {
      const looks = $$('[data-look]', sec), tabs = $$('[data-look-tab]', sec);
      const auto = +(sec.dataset.autoplay || 0) * 1000;
      let cur = 0, timer = null, paused = false;
      /* paski jak w relacjach na Instagramie */
      if (looks.length > 1) looks.forEach(lk => { const ph = $('.lk__photo', lk); if (ph && !$('.lk__bars', ph)) ph.insertAdjacentHTML('afterbegin', `<div class="lk__bars">${looks.map(() => '<i><b></b></i>').join('')}</div>`); });
      const bars = () => looks.forEach(lk => $$('.lk__bars i', lk).forEach((b, k) => { b.classList.toggle('done', k < cur); b.classList.toggle('now', k === cur); const f = $('b', b); if (f) { f.style.transition = 'none'; f.style.width = (k < cur || (k === cur && !auto)) ? '100%' : '0'; } }));
      const run = () => {
        clearTimeout(timer); if (!auto || paused || looks.length < 2) return;
        const f = $(`.lk__bars i:nth-child(${cur + 1}) b`, looks[cur]);
        if (f) { void f.offsetWidth; f.style.transition = `width ${auto}ms linear`; f.style.width = '100%'; }
        timer = setTimeout(() => show(cur + 1, 1), auto);
      };
      let busy = false;
      const swap = (i, dir) => {
        const prev = cur; cur = i;
        looks.forEach((l, k) => l.hidden = k !== i);
        tabs.forEach((t, k) => t.setAttribute('aria-selected', k === i));
        const t = tabs[i]; if (t) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
        const lk = looks[i], ph = $('.lk__photo', lk);
        if (ph && prev !== i) {
          ph.style.transition = 'none'; ph.style.opacity = '';
          ph.classList.remove('in-next', 'in-prev'); ph.style.transform = ''; void ph.offsetWidth;
          ph.classList.add(dir > 0 ? 'in-next' : 'in-prev');
          lk.classList.remove('lk--in'); void lk.offsetWidth; lk.classList.add('lk--in');
        }
        [i + 1, i - 1].forEach(k => { const l = looks[(k + looks.length) % looks.length]; $$('.lk__photo img', l).forEach(im => im.loading = 'eager'); });
        bars(); run();
      };
      const show = (i, dir) => {
        i = (i + looks.length) % looks.length;
        if (i === cur || busy) return;
        dir = dir || (i > cur ? 1 : -1);
        const old = $('.lk__photo', looks[cur]);
        if (!old || matchMedia('(prefers-reduced-motion: reduce)').matches) return swap(i, dir);
        busy = true; clearTimeout(timer);
        old.style.transformOrigin = dir > 0 ? '100% 50%' : '0% 50%';
        old.style.transition = 'transform .4s cubic-bezier(.55,.05,.7,.4), filter .4s ease';
        old.style.transform = `rotateY(${dir > 0 ? -88 : 88}deg)`; old.style.filter = 'brightness(.55)';
        setTimeout(() => { old.style.transition = 'none'; old.style.transform = ''; old.style.filter = ''; old.style.transformOrigin = ''; busy = false; swap(i, dir); }, 390);
      };
      tabs.forEach((t, k) => t.addEventListener('click', () => show(k)));
      /* przesuwanie palcem po zdjęciu */
      looks.forEach(lk => {
        const ph = $('.lk__photo', lk); if (!ph || looks.length < 2) return;
        let x0 = 0, y0 = 0, dx = 0, axis = null;
        ph.addEventListener('touchstart', e => { const p = e.touches[0]; x0 = p.clientX; y0 = p.clientY; dx = 0; axis = null; ph.style.transition = 'none'; paused = true; clearTimeout(timer); }, { passive: true });
        ph.addEventListener('touchmove', e => {
          const p = e.touches[0], mx = p.clientX - x0, my = p.clientY - y0;
          if (!axis) axis = Math.abs(mx) > Math.abs(my) + 4 ? 'x' : (Math.abs(my) > 6 ? 'y' : null);
          if (axis !== 'x') return;
          e.preventDefault(); dx = mx;
          ph.style.transformOrigin = dx < 0 ? '100% 50%' : '0% 50%'; const ang = Math.max(-70, Math.min(70, dx / ph.offsetWidth * 80)); ph.style.transform = `rotateY(${ang}deg)`; ph.style.filter = `brightness(${1 - Math.abs(ang) / 160})`;
        }, { passive: false });
        const end = () => {
          paused = false;
          if (axis === 'x' && Math.abs(dx) > 50) { show(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); }
          else { ph.style.transition = 'transform .5s cubic-bezier(.22,.61,.36,1), filter .5s ease'; ph.style.transform = ''; ph.style.filter = ''; run(); }
        };
        ph.addEventListener('touchend', end); ph.addEventListener('touchcancel', end);
        /* dotknięcie lewej/prawej krawędzi – jak w relacjach */
        ph.addEventListener('click', e => { if (e.target.closest('[data-hs]')) return; const r = ph.getBoundingClientRect(), x = e.clientX - r.left; if (x < r.width * .22) show(cur - 1, -1); else if (x > r.width * .78) show(cur + 1, 1); });
      });
      bars(); run();
      looks.forEach((lk, idx) => {
        const items = $$('.li', lk), sel = {};
        items.forEach(li => { if (li.dataset.variant) sel[li.dataset.li] = li.dataset.variant; });
        const sync = () => {
          let tot = 0, n = 0;
          items.forEach(li => { if (li.dataset.on === 'true') { tot += +li.dataset.price; n++; } });
          $('[data-look-total]', lk).textContent = money(tot);
          const b = $('[data-look-add]', lk); b.disabled = !n; b.textContent = (T.addLook || '').replace('{n}', n);
        };
        lk.addEventListener('nc:size', e => { const li = e.target.closest('.li'); sel[li.dataset.li] = e.detail.id; li.dataset.on = 'true'; $('[data-err]', li).textContent = ''; sync(); });
        lk.addEventListener('click', async e => {
          const hs = e.target.closest('[data-hs]');
          if (hs) { const li = $(`.li[data-li="${hs.dataset.hs}"]`, lk); $$('.hs', lk).forEach(x => x.classList.toggle('on', x === hs)); if (li) { li.classList.add('flash'); setTimeout(() => li.classList.remove('flash'), 900); li.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } return; }
          const chk = e.target.closest('.li__chk');
          if (chk) { const li = chk.closest('.li'); if (li.dataset.avail !== 'true') return openNotify(li.dataset.title, ''); li.dataset.on = li.dataset.on !== 'true'; return sync(); }
          if (e.target.closest('[data-look-prev]')) return show(idx - 1, -1);
          if (e.target.closest('[data-look-next]')) return show(idx + 1, 1);
          const add = e.target.closest('[data-look-add]');
          if (add) {
            const on = items.filter(li => li.dataset.on === 'true'); let miss = null;
            on.forEach(li => { if (!sel[li.dataset.li]) { $('[data-err]', li).textContent = T.selectSize; miss = miss || li; } });
            if (miss) return miss.scrollIntoView({ behavior: 'smooth', block: 'center' });
            add.disabled = true;
            const img = $('.lk__photo img', lk);
            await addItems(on.map(li => ({ id: +sel[li.dataset.li], quantity: 1 })), { text: $('.lk__t', lk).textContent, img: img && img.currentSrc });
            add.disabled = false;
          }
        });
        sync();
      });
    });
  }

  /* ---------- kolekcja: filtry ---------- */
  function initFilters() {
    const plp = $('[data-plp]'); if (!plp) return;
    const panel = $('[data-filter-panel]', plp), form = $('[data-filter-form]', plp);
    const isSidebar = () => panel && panel.classList.contains('side') && innerWidth >= 900;
    $$('[data-filter-open]', plp).forEach(b => b.addEventListener('click', () => { if (!panel) return; panel.classList.add('on'); document.body.classList.add('lock', 'panel-open'); }));
    $$('[data-filter-close]', plp).forEach(b => b.addEventListener('click', () => { panel.classList.remove('on'); document.body.classList.remove('lock', 'panel-open'); }));
    if (form) {
      form.addEventListener('change', () => { if (isSidebar()) submitFilters(form); });
      form.addEventListener('submit', e => { e.preventDefault(); submitFilters(form); });
    }
    $$('.acc-h', plp).forEach(b => b.addEventListener('click', () => b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') !== 'true')));
    const grid = $('[data-grid]', plp);
    const setView = v => { $$('[data-view]', plp).forEach(b => b.setAttribute('aria-pressed', b.dataset.view === v)); if (grid) grid.classList.toggle('big', v === 'big'); store.set('view', v); };
    $$('[data-view]', plp).forEach(b => b.addEventListener('click', () => setView(b.dataset.view)));
    if ($('[data-view]', plp)) setView(store.get('view', 'grid'));
  }
  function submitFilters(form) {
    const fd = new FormData(form), q = new URLSearchParams();
    for (const [k, v] of fd.entries()) if (v !== '') q.append(k, v);
    location.href = form.action + (q.toString() ? '?' + q.toString() : '');
  }

  /* ---------- wyszukiwarka z podpowiedziami ---------- */
  function initSearch() {
    const inp = $('[data-search-input]'); if (!inp) return;
    const out = $('[data-search-results]'), def = $('[data-search-default]');
    let tm;
    inp.addEventListener('input', () => {
      clearTimeout(tm);
      const q = inp.value.trim();
      if (!q) { out.innerHTML = ''; if (def) def.hidden = false; return; }
      tm = setTimeout(async () => {
        try {
          const r = await fetch(`${NC.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`);
          const d = await r.json(); const ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (def) def.hidden = true;
          out.innerHTML = `<p class="lab">${esc(T.results)} (${ps.length})</p>` + (ps.length ? `<div class="srch__res">${ps.map(p => `<a class="pc" href="${p.url}"><span class="pc__m"><img class="on" src="${imgW(p.featured_image && p.featured_image.url || p.image, 500)}" alt="" loading="lazy"></span><span class="pc__n">${esc(p.title)}</span><span class="pc__p">${money(Math.round(parseFloat(p.price) * 100))}</span></a>`).join('')}</div><p class="srch__all"><a class="u-link" href="${NC.routes.search}?q=${encodeURIComponent(q)}&options[prefix]=last">${esc(T.viewAll)}</a></p>` : `<p>${esc(T.noResults)}</p>`);
        } catch (e) {}
      }, 220);
    });
  }

  /* ---------- karta produktu: przewijanie zdjęć ---------- */
  function slide(btn) {
    const m = btn.closest('.pc__m, .pc'), ims = $$('.pc__m img', m.closest('.pc')), dots = $$('.pc__dots i', m.closest('.pc'));
    let i = ims.findIndex(x => x.classList.contains('on')); if (i < 0) i = 0;
    i = (i + +btn.dataset.slide + ims.length) % ims.length;
    ims.forEach((x, k) => x.classList.toggle('on', k === i)); dots.forEach((x, k) => x.classList.toggle('on', k === i));
  }

  /* ---------- zdarzenia globalne ---------- */
  document.addEventListener('click', e => {
    const el = e.target.closest('[data-open],[data-close],[data-scrim],[data-modal-close],[data-wish],[data-line],[data-size-chart],[data-share],[data-slide],[data-acc-foot],[data-recover-open],[data-recover-close],[data-sub-toggle]');
    if (!el) { if (!e.target.closest('[data-select]')) closeSelects(); if (e.target.matches('[data-modal]')) closeModal(); if (!e.target.closest('[data-header]')) closeMega(); return; }
    if (el.dataset.open) { e.preventDefault(); return setPanel(openId === el.dataset.open ? null : el.dataset.open); }
    if (el.hasAttribute('data-close') || el.hasAttribute('data-scrim')) { $$('[data-filter-panel]').forEach(p => p.classList.remove('on')); return setPanel(null); }
    if (el.hasAttribute('data-modal-close')) return closeModal();
    if (el.dataset.wish) { e.preventDefault(); return toggleWish(el.dataset.wish); }
    if (el.dataset.line) { e.preventDefault(); return changeLine(+el.dataset.line, +el.dataset.q); }
    if (el.hasAttribute('data-size-chart')) { e.preventDefault(); return modal(fromTpl('tpl-size-chart')); }
    if (el.hasAttribute('data-slide')) { e.preventDefault(); return slide(el); }
    if (el.hasAttribute('data-acc-foot')) { if (innerWidth < 900) el.parentElement.classList.toggle('open'); return; }
    if (el.hasAttribute('data-sub-toggle')) { const s = document.getElementById(el.getAttribute('aria-controls')); if (s) { s.hidden = !s.hidden; el.setAttribute('aria-expanded', !s.hidden); } return; }
    if (el.hasAttribute('data-recover-open')) { e.preventDefault(); $('[data-login]').hidden = true; $('[data-recover]').hidden = false; return; }
    if (el.hasAttribute('data-recover-close')) { e.preventDefault(); $('[data-login]').hidden = false; $('[data-recover]').hidden = true; return; }
    if (el.hasAttribute('data-share')) {
      e.preventDefault();
      (async () => { try { if (navigator.share) await navigator.share({ title: document.title, url: location.href }); else { await navigator.clipboard.writeText(location.href); toast(T.linkCopied); } } catch (err) {} })();
    }
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') { closeModal(); closeSelects(); closeMega(); setPanel(null); $$('[data-filter-panel]').forEach(p => p.classList.remove('on')); } });
  $$('[data-locale-select]').forEach(s => s.addEventListener('change', () => s.form.submit()));

  /* ---------- start ---------- */
  function init() {
    $$('[data-select]').forEach(initSelect);
    initMega(); initMobileMenu(); initCardSwipe(); initPdpBundle(); initHeader(); initHero(); initCarousels(); initProduct(); initEta(); initLooks(); initFilters(); initSearch(); initRecs(); initRecent();
    syncWish(); renderWishlist();
    if ($('[data-cart-count]')) getCart().then(c => setCounts(c.item_count)).catch(() => {});
    if (/contact_posted=true/.test(location.search) && store.get('notify_pending', 0)) { store.set('notify_pending', 0); toast(T.notifyOk); }
    if (/customer_posted=true/.test(location.search)) { const n = document.querySelector('.sec-news, .news'); if (n) n.scrollIntoView({ block: 'center' }); }
    /* edytor motywu: ponowna inicjalizacja po zmianie sekcji */
    document.addEventListener('shopify:section:load', e => { $$('[data-select]', e.target).forEach(initSelect); initHero(); initCarousels(e.target); initLooks(); initEta(); syncWish(); });
    document.addEventListener('shopify:block:select', e => { const l = e.target.closest('[data-look]'); if (l) { const sec = l.closest('[data-look-section]'), i = $$('[data-look]', sec).indexOf(l); const t = $$('[data-look-tab]', sec)[i]; if (t) t.click(); } });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  window.NCtheme = { money, toast, setPanel, addItems, openNotify };
})();
